import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { de, en } from 'vuetify/locale'

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    theme: {
      defaultTheme: 'light',
    },
    locale: {
      locale: 'de',
      fallback: 'en',
      messages: { de, en },
    },
  })
  app.vueApp.use(vuetify)
})
